import React from "react";
import { WeekData, formatWeekRange } from "../../utils/weekUtils";
import { useCountdown, formatCountdown } from "../../hooks/useCountdown";

interface WeekCardProps {
  week: WeekData;
  onClick: () => void;
}

/**
 * WeekCard component displays a card for a specific week
 * Shows week range, label, and countdown (if current week)
 */
const WeekCard: React.FC<WeekCardProps> = ({ week, onClick }) => {
  const countdown = useCountdown();
  const weekRange = formatWeekRange(week.startDate, week.endDate);

  return (
    <div
      className={`week-card ${week.isCurrentWeek ? "current-week" : ""}`}
      onClick={onClick}
    >
      <div className="week-card-content">
        <div className="week-label">{week.label}</div>
        <div className="week-range">{weekRange}</div>
        {week.isCurrentWeek && (
          <div className="week-countdown">{formatCountdown(countdown)}</div>
        )}
      </div>
      <div className="week-card-arrow">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default WeekCard;
